import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCashbox, getEmployee } from "../../../../redux/actions/handbookAction";

const useEmployees = (cashBoxId) => {
  const { users, usersLoading, cashbox } = useSelector(({ handbook }) => handbook);

  const dispatch = useDispatch();
  const [employeeOptions, setEmployeeOptions] = useState([
    { value: 0, label: null },
  ]);

  const handleGetEmployee = (inputValue, action) => {
    if (action.action === "input-change" && inputValue.length >= 2) {
      dispatch(
        getEmployee({
          bySearch: inputValue,
          document: true,
          active: "active=true",
        })
      );
    }
  };

  useEffect(() => {
    if(cashBoxId) dispatch(getCashbox({id: cashBoxId}))
  }, [cashBoxId])

  useEffect(() => {
    const options = users?.length
      ? users.map(({ id, fullName }) => ({ value: id, label: fullName }))
      : [];
    setEmployeeOptions(options);
  }, [users]);

  return { employeeOptions, handleGetEmployee, usersLoading, cashboxesLeader: cashbox?.leader };
};

export default useEmployees;
